import { ReactNode, useMemo } from 'react';
import { ClientAccountListContext } from './ClientAccountListContext';
import { ClientAccountListHostProps } from './types';

type ClientAccountListProviderProps = ClientAccountListHostProps & {
  children: ReactNode;
};

// Feature-local, not app-level: the Client Account List root mounts this with the props the host passed
// it, so the feature's internal children (the table config) read useClientAccountList() instead of being
// handed account/hostPaths one level at a time. Deliberately not exported from the package barrel — the
// host mounts only the root and passes props.
export default function ClientAccountListProvider({ account, hostPaths, children }: ClientAccountListProviderProps) {
  const value = useMemo(() => ({ account, hostPaths }), [account, hostPaths]);

  return <ClientAccountListContext.Provider value={value}>{children}</ClientAccountListContext.Provider>;
}
